import { AxisLabels } from './axis-labels';
import { GridPlane } from './grid-plane';

export const Grid3D = ({
  origin,
  breadth,
  length,
  height,
  tickLength,
  color = '#cccccc',
  opacity = 1,
  unit = 'ft',
}: {
  origin: {
    x: number;
    y: number;
    z: number;
  };
  breadth: number;
  length: number;
  height: number;
  tickLength: {
    xTickLength: number;
    yTickLength: number;
    zTickLength: number;
  };
  color?: string;
  opacity?: number;
  unit?: string;
}) => {
  return (
    <group>
      <GridPlane
        origin={{ ...origin, y: origin.y + length }}
        primaryAxis="x"
        secondaryAxis="z"
        primarySize={breadth}
        secondarySize={height}
        primaryDivisionUnit={tickLength.xTickLength}
        secondaryDivisionUnit={tickLength.zTickLength}
        color={color}
        opacity={opacity}
      />
      <GridPlane
        origin={origin}
        primaryAxis="y"
        secondaryAxis="z"
        primarySize={length}
        secondarySize={height}
        primaryDivisionUnit={tickLength.yTickLength}
        secondaryDivisionUnit={tickLength.zTickLength}
        color={color}
        opacity={opacity}
      >
        <AxisLabels
          axis="y"
          showAxisValue={false}
          origin={origin}
          dimension={length}
          divisionUnit={tickLength.yTickLength}
          labelOffset={{ x: breadth + 100, y: 0, z: 0 }}
          axisName={`Y (${unit})`}
          showAxisName
        />
        <AxisLabels
          axis="z"
          origin={origin}
          dimension={height}
          divisionUnit={tickLength.zTickLength}
          labelOffset={{ x: -100, y: -100, z: 0 }}
          axisName={`Z (${unit})`}
          showAxisName
        />
      </GridPlane>
      <GridPlane
        origin={origin}
        primaryAxis="x"
        secondaryAxis="y"
        primarySize={breadth}
        secondarySize={length}
        primaryDivisionUnit={tickLength.xTickLength}
        secondaryDivisionUnit={tickLength.yTickLength}
        color={color}
        opacity={opacity}
      >
        <AxisLabels
          axis="x"
          origin={origin}
          showAxisValue={false}
          dimension={breadth}
          divisionUnit={tickLength.xTickLength}
          labelOffset={{ x: 0, y: -100, z: 0 }}
          axisName={`X (${unit})`}
          showAxisName
        />
      </GridPlane>
    </group>
  );
};
